import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const SurveyErrorModal = ({ isOpen, toggle }) => {
  // Generate unique IDs for accessibility
  const modalId = 'survey-error-modal'
  const modalTitleId = 'survey-error-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="error.redemption.surveyTitle" />
        </h2>
        <p>
          <FormattedMessage id="error.redemption.surveyDescription" />
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button block outline color="danger" onClick={toggle} aria-label="Close this message">
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

SurveyErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default SurveyErrorModal
